import React from "react";
import { sendClientSideSplitTrackEvent } from "@leafly-com/split-next";
import Link from "next/link";

import { Action, Category } from "constants/events";
import { PRODUCT_CATEGORY_NAMES } from "constants/products";
import { useEventTracker } from "hooks/useEventTracker";
import { getSplitKey } from "utils/split/getSplitKey";

import IconSvg from "components/IconSvg";

type Props = {
  className?: string;
  title?: string;
};

const ProductCoinList: React.FC<Props> = ({ className, title }) => {
  const { publishEvent } = useEventTracker();

  const coinCategories = Object.keys(PRODUCT_CATEGORY_NAMES);

  return (
    <div className={className}>
      {title && <h2 className="heading--m font-extrabold mb-md">{title}</h2>}
      <div className="overflow-x-auto">
        <ul data-testid="coin-list" className="flex gap-lg">
          {coinCategories.map((category) => (
            <Coin
              key={category}
              href={PRODUCT_CATEGORY_NAMES[category].path}
              onClick={() => {
                publishEvent({
                  action: Action.click,
                  category: Category.productCategoryCoinFilter,
                  label: PRODUCT_CATEGORY_NAMES[category].label,
                });

                sendClientSideSplitTrackEvent(
                  {
                    eventType: "SHH-785_root_category_coinlist_click",
                    properties: {
                      linkText: PRODUCT_CATEGORY_NAMES[category].label,
                    },
                  },
                  getSplitKey(),
                );
              }}
              title={PRODUCT_CATEGORY_NAMES[category].label}
              category={category}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

const Coin = ({
  category,
  onClick,
  href,
  title,
}: {
  category: string;
  onClick: () => void;
  href: string;
  filterable?: boolean;
  title: string;
}) => {
  return (
    <li key={category} className="flex-shrink-0 mb-2 md:mb-none min-w-20 w-20">
      <Link
        href={href}
        onClick={onClick}
        className="flex border border-grey-44 flex-col items-center justify-center h-[80px] bg-green-20 rounded-[8px]"
        data-testid={`${category}-products-category`}
      >
        <IconSvg
          className={`flex items-center text-white ${
            category === "Cannabis" && "pt-1"
          }`}
          width={category === "Cannabis" ? "44" : "50"}
          height={category === "Cannabis" ? "42" : "50"}
          filePath={`coinList/${PRODUCT_CATEGORY_NAMES[category].icon}.svg`}
        />
        <span className="text-xs">{title}</span>
      </Link>
    </li>
  );
};

export default ProductCoinList;
